<template>
  <el-date-picker
    v-model="getPeriod"
    type="daterange"
    align="right"
    unlink-panels
    :clearable="false"
    range-separator="До"
    format="dd.MM.yyyy"
    start-placeholder="нач. период"
    end-placeholder="конеч. период"
    size="mini"
    @change="handleChange"
    :picker-options="pickerOptions"
    :default-time="defaultTime"
  />
</template>

<script>
  /*
   дата пикер переиспользуемый
  */

// config
import { getPickerOptions } from "./config";

// libraries
import moment from "moment/moment";

// actions
import { GET_AUDIT, SET_AUDIT_PERIOD, SET_AUDIT_PERIOD_NAME } from "../../store/actions/audit";

//mixins
import {dateRangeSafari} from '@/mixins/dateRangeSafari';

export default {
  name: "PeriodRange",
  props: {
    chartName: {
      type: String
    },
    reload: {
      type: String
    }
  },
  data() {
    return {
      defaultTime: ["00:00:00", "23:59:59"],
      format: "YYYY-MM-DD HH:mm:ss",
      isChanged: false,
    };
  },
  methods: {
    handleChange() {
      this.isChanged = true;
    },
    getTitle({title}) {
      this.$store.dispatch(SET_AUDIT_PERIOD_NAME, {title, chart: this.chartName});
    },
    getLocalPeriod() {
        const localPeriod = this.$store.getters.getAuditPeriod(this.chartName).map(item => item.replace(" ", "T"))
        const retro_max = this.$store.getters.retro_max(this.$route.params.threadId)
        const retrospective = this.$store.getters.retrospective(this.$route.params.threadId)
        let end = new Date(retro_max);
        end.setDate(end.getDate() - 1);
        let condition = retro_max != null && new Date(retro_max) < new Date(localPeriod[1])
        return [`${condition ? retrospective : localPeriod[0].replace(" ", "T")}`, `${condition ? end.toJSON().split('T')[0] : localPeriod[1].split(' ')[0]}`.replace(" ", "T")];
    }
  },
  computed: {
    pickerOptions() {
      return getPickerOptions(
        this.$store.getters.retrospective(this.$route.params.threadId),
        this.getTitle
      );
    },
    getPeriod: {
      get() {
        /*let period = this.$store.getters.getAuditPeriod(this.chartName);
        period = this.prepareLastDate(period);
        return period.map(item => item.replace(" ", "T"));*/
        return this.getLocalPeriod()

      },
      set(value) {
        let period = value;

        const diff = Math.round(( Date.parse(period[0]) - Date.parse(period[1]) ) / 86400000) + 1;

        if (diff === 1) {
          const startDate = new Date(period[0]);

          startDate.setHours(0);
          startDate.setMinutes(0);
          startDate.setSeconds(0);

          period = [startDate, new Date()];

        }

        this.$store.dispatch(SET_AUDIT_PERIOD, {
          chart: this.chartName,
          period: period.map(item => moment(item).format(this.format))
        });

        this.$store.dispatch(GET_AUDIT, {chart: this.chartName, thread: this.$route.params.threadId});

        if (this.reload) {
          this.$store.dispatch(SET_AUDIT_PERIOD, {
            chart: this.reload,
            period: period.map(item => moment(item).format(this.format))
          });

          this.$store.dispatch(GET_AUDIT, {chart: this.reload, thread: this.$route.params.threadId});
        }

      }
    }
  },
    beforeMount() {
    this.$store.dispatch(SET_AUDIT_PERIOD, {
      chart: this.chartName,
      period: this.getLocalPeriod()
    });
  },
  mixins: [
    dateRangeSafari
  ]
};
</script>
